module.exports = __webpack_public_path__ + "static/media/Varada_logo_w.57d2179b.png";